import PostPreview from './post-preview'

interface SubPostsProps {
  posts: Blog.AllPosts
}

const SubPosts: React.FC<SubPostsProps> = ({ posts }) => (
  <section>
    <div className='relative py-6 lg:py-10'>
      <div className='relative mx-auto max-w-7xl'>
        <div className='mx-auto grid max-w-sm gap-6 md:max-w-none md:grid-cols-2 lg:gap-9'>
          {/* eslint-disable-next-line react/no-unused-prop-types */}
          {posts.map(({ node }: { node: Blog.Posts }) => (
            <PostPreview
              key={node.slug}
              author={node.author?.node}
              category={node.categories?.edges[0].node.name}
              coverImage={node.featuredImage?.node}
              date={node.date}
              excerpt={node.excerpt}
              height='h-48 lg:h-48 xl:h-64'
              slug={node.slug}
              title={node.title}
            />
          ))}
        </div>
      </div>
    </div>
  </section>
)

export default SubPosts
